import { AsidePanelActionsButton } from '../../../../..';
import * as React from 'react';
import { IMoveToPanelButtonProps } from './types';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { BOARD_MOVE_TO_SECTION_TITLE } from '../MoveToSection/constants';

export function MoveToPanelButton ({
    isShow,
    onClick
}: IMoveToPanelButtonProps) {
    const { subTab, setSubTab } = React.useContext(AsidePanelContext);
    if (!isShow) return null;
    return (
        <AsidePanelActionsButton
            children={null}
            isOpened={subTab === EBoardSetting.MOVE_TO}
            title={BOARD_MOVE_TO_SECTION_TITLE}
            onClick={() => {
                setSubTab(EBoardSetting.MOVE_TO);
                onClick();
            }}
        />
    );
}
